module.exports = __webpack_public_path__ + "img/logo.b15364b2.png";